import { render, staticRenderFns } from "./QuesList.vue?vue&type=template&id=a775b920&scoped=true&"
import script from "./QuesList.vue?vue&type=script&lang=ts&"
export * from "./QuesList.vue?vue&type=script&lang=ts&"
import style0 from "./QuesList.vue?vue&type=style&index=0&id=a775b920&lang=scss&scoped=true&vars=%7Bques-theme-bg%7D&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@rakete/cli-plugin-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a775b920",
  null
  
)

export default component.exports